import React, { useState, useEffect, useRef } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  ListGroup,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import toastr from "toastr";
import CustomNavbar from "../../components/CustomNavbar";
import SidebarConfig from "../../components/SidebarConfig";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";
import config from "../../config";
import messages from "../../redux/messages";
import {
  getEmployees,
  saveEmployee,
  editEmployee,
  deleteEmployee,
  getGlobalEmployees,
} from "../../redux/employees/actions";
import { getAreasDescFicha } from "../../redux/descriptorsProfiles/areas/actions";
import { getEmployeesHierarchy } from "../../redux/employeesHierarchy/actions";
import { getJobPositions } from "../../redux/jobposition/actions";
import { getAreasJerarquia } from "../../redux/areasfuncional/actions";
import { getCenterCost } from "../../redux/centercost/actions";
import { getCivilState } from "../../redux/civilstate/actions";
import { getDivision } from "../../redux/division/actions";
import { getAuroraDivision } from "../../redux/auroraDivision/actions";
import { getEmploymentRel } from "../../redux/employmentrelationShipFuncional/actions";
import { getCurrentSituation } from "../../redux/currentSituation/actions";
import { getPersonalDivision } from "../../redux/divisionPersonal/actions";
import { getClassification } from "../../redux/Classification/actions";
import { get_tasks } from "../../redux/tasks/actions";
import perfilImage from "../../images/perfil3.jpg";
import LinkDescargaGD from "../../components/gestorDocumental/LinkDescargaGD";
import { getBase64 } from "../../components/gestorDocumental/GestorDocumental";
import { getAreas, getCarpetas } from "../../redux/gestorDocumental/actions";
import { Typeahead } from "react-bootstrap-typeahead";
import { getMunicipalityUser } from "../../redux/municipalityUser/actions";
import { getDepartamentUser } from "../../redux/departamentUser/actions";
import { getCountryUser } from "../../redux/countryUser/actions";
import { getCompanias } from '../../redux/compania/actions';
import "../../css/employees.css" /* sobreescribir los estilos de valdación de los typeaheads */
const Employees = (props) => {
  const filters = [
    { num: 1, id: "codigo", desc: "Código de empleado" },
    { num: 2, id: "nombre", desc: "Nombre de empleado" },
    { num: 3, id: "centro_costo", desc: "Centro de costo" },
    { num: 4, id: "funcion", desc: "Función" },
    { num: 5, id: "puesto", desc: "Puesto" },
    { num: 6, id: "unidad_organizativa", desc: "Unidad organizativa" },
  ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalMenu, setShowModalMenu] = useState(false);
  const [isReqDateFieldFileGD, setIsReqDateFieldFileGD] = useState(false);
  const [estadoCivilError, setEstadoCivilError] = useState(false);
  const [croquisError, setCroquisError] = useState(false);
  const [fechaEntregaError, setfechaEntregaError] = useState(false);
  const [ec, setEc] = useState("");
  //parametros para el modal menu
  const [employeeId, setemployeeId] = useState("");
  const [employeeName, setemployeeName] = useState("");
  //const [itype, setItype] = ('');

  const [filter, setFilter] = useState(
    parseInt(props.match.params.searchtype) !== 1
      ? props.match.params.filter
      : ""
  );
  const [tipoBusqueda, setTipoBusqueda] = useState(
    props.match.params.searchFilter &&
      filters.find((f) => f.num === parseInt(props.match.params.searchFilter))
      ? filters.find((f) => f.num === parseInt(props.match.params.searchFilter))
      : filters[0]
  );
  const [show, setShow] = useState(false);
  //const [loadingType, setLoadingType] = useState('initial');
  const [validated, setValidated] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const [Search, setSearch] = useState(false);

  const imgRef = useRef();

  const dispatch = useDispatch();

  const data = useSelector((store) => store.employees.employees);
  const dataLenght = useSelector((store) => store.employees.employeesLength);
  const pages = Math.ceil(dataLenght / limit);
  const loading = useSelector((store) => store.employees.loading);
  const saveLoading = useSelector((store) => store.employees.saveLoading);
  const jobs = useSelector((store) => store.jobPositions.jobPositions);
  const loadingJobs = useSelector((store) => store.jobPositions.loading);
  const areas = useSelector((store) => store.areas.areas);
  const loadingAreas = useSelector((store) => store.areas.loading);
  //centercost
  const centerCost = useSelector((store) => store.centerCost.centerCost);
  const centerCostLoader = useSelector((store) => store.centerCost.loading);
  //employment
  const employmentRelation = useSelector(
    (store) => store.employmentRelationShipFuncional.employmentRelationShip
  );
  const employmentRelationLoader = useSelector(
    (store) => store.employmentRelationShipFuncional.loading
  );
  //division
  const division = useSelector((store) => store.division.division);
  const divisionLoader = useSelector((store) => store.division.loading);
  //division
  const civilState = useSelector((store) => store.civilState.civilState);
  const civilStateLoader = useSelector((store) => store.civilState.loading);

  //aurora division
  const auroraDivision = useSelector((store) => store.auroraDivision.auroraDivision);
  const auroraDivisionLoader = useSelector((store) => store.auroraDivision.loading);

  //empresa 
  const compania = useSelector((store) => store.compania.compania);
  const companiaLoader = useSelector((store) => store.compania.loading);

  //currentSituation
  const currentSituation = useSelector(
    (store) => store.currentSituation.currentSituation
  );
  const currentSituationLoader = useSelector(
    (store) => store.currentSituation.loading
  );

  //gender
  //const gender = useSelector(store => store.genders.genders);
  //const genderLoader = useSelector(store => store.genders.loading);

  //personalDivision
  const personalDivision = useSelector(
    (store) => store.divisionPersonal.divisionPersonal
  );
  const personalDivisionLoader = useSelector(
    (store) => store.divisionPersonal.loading
  );

  //employeeHierarchy
  const employeesHierarchy = useSelector(
    (store) => store.employeesHierarchy.employees
  );
  const employeesHierarchyLoader = useSelector(
    (store) => store.employeesHierarchy.loading
  );

  const classification = useSelector(
    (store) => store.classification.classification
  );
  const classificationLoader = useSelector(
    (store) => store.classification.loading
  );

  const tasks = useSelector((store) => store.tasks.tasks);
  const tasksLoader = useSelector((store) => store.tasks.saveLoader);

  const gdAreas = useSelector((store) => store.gestorDocumental.areas);
  const loadingGDAreas = useSelector(
    (store) => store.gestorDocumental.loadingAreas
  );
  // loader country
  const countryLoader = useSelector(
    (store) => store.countryUser.loaderCountryUser
  );

  const { loadingCarpetas, carpetas, areasError, carpetasError } = useSelector(
    (store) => store.gestorDocumental
  );

  const { loaderAreas: loadingAreasDesc, areasDesc } = useSelector(
    (store) => store.areasDescriptoresPerfiles
  );

  //* Variables
  const { estadoCivil, domicilio, email } = config.gestorDocumental;


  //* Typeahead options
  const centerCostOptions = centerCost
    ? centerCost
      .sort((a, b) => {
        if (a.descripcion && b.descripcion) {
          return a.descripcion.toLowerCase().localeCompare(b.descripcion.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.codigo}/${item.descripcion}`,
        item: item,
      }))
    : [];


  const tasksOptions = tasks
    ? tasks
      .sort((a, b) => {
        if (a.descripcion && b.descripcion) {
          return a.descripcion.toLowerCase().localeCompare(b.descripcion.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.codigo}/${item.descripcion}`,
        item: item,
      }))
    : [];

  let jobsOptions = jobs
    ? jobs
      .sort((a, b) => {
        if (a.descripcion && b.descripcion) {
          return a.descripcion.toLowerCase().localeCompare(b.descripcion.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.codigo}/${item.descripcion}`,
        item: item,
      }))
    : [];

  let unidadesOrganizativasOptions = areas
    ? areas
      .sort((a, b) => {
        if (a.nombre && b.nombre) {
          return a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.codigo}/${item.nombre}`,
        item: item,
      }))
    : [];

  let auroraDivisionOptions = auroraDivision
    ? auroraDivision
      .sort((a, b) => {
        if (a.nombre && b.nombre) {
          return a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.nombre}`,
        item: item,
      }))
    : [];

  const companiesOptions = compania
    ? compania
      .sort((a, b) => {
        if (a.nombre && b.nombre) {
          return a.nombre.toLowerCase().localeCompare(b.nombre.toLowerCase());
        }
        return 1;
      })
      .map((item) => ({
        id: item.id,
        label: `${item.codigo}/${item.nombre}`,
        item: item,
      }))
    : [];

  const columns = [
    {
      Header: "Código",
      accessor: "codigo",
    },
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
          <Button
            variant="link"
            size="sm"
            type="button"
            className="text-info"
            onClick={() =>
              onModalMenu(value.row.original.id, value.row.original.nombre)
            }
          >
            <i className="material-icons">menu</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getAEmployees = (offs = offset, lim = limit, filt = filter) => {
    const searchParams =
      parseInt(props.match.params.searchtype) === 1
        ? {
          orga: props.match.params.id,
          offset: offs,
          limit: lim,
          // filter: filt,
          filter:
            filt !== ""
              ? JSON.stringify({
                codigo__icontains:
                  tipoBusqueda.id === "codigo" ? filt : undefined,
                nombre__icontains:
                  tipoBusqueda.id === "nombre" ? filt : undefined,
                centro_costo__descripcion__icontains:
                  tipoBusqueda.id === "centro_costo" ? filt : undefined,
                posicion__descripcion__icontains:
                  tipoBusqueda.id === "funcion" ? filt : undefined,
                puesto__descripcion_larga__icontains:
                  tipoBusqueda.id === "puesto" ? filt : undefined,
                unidad_organizativa__nombre__icontains:
                  tipoBusqueda.id === "unidad_organizativa"
                    ? filt
                    : undefined,
              })
              : undefined,
          activo: "",
        }
        : {
          offset: offs,
          limit: lim,
          // filter: filt,
          filter:
            filt !== ""
              ? JSON.stringify({
                codigo__icontains:
                  tipoBusqueda.id === "codigo" ? filt : undefined,
                nombre__icontains:
                  tipoBusqueda.id === "nombre" ? filt : undefined,
                centro_costo__descripcion__icontains:
                  tipoBusqueda.id === "centro_costo" ? filt : undefined,
                posicion__descripcion__icontains:
                  tipoBusqueda.id === "funcion" ? filt : undefined,
                puesto__descripcion_larga__icontains:
                  tipoBusqueda.id === "puesto" ? filt : undefined,
                unidad_organizativa__nombre__icontains:
                  tipoBusqueda.id === "unidad_organizativa"
                    ? filt
                    : undefined,
              })
              : undefined,
          activo: "",
        };

    if (parseInt(props.match.params.searchtype) === 1) {
      dispatch(getEmployees(searchParams, parseInt(props.match.params.oType)));
    } else {
      dispatch(
        getGlobalEmployees(searchParams, parseInt(props.match.params.oType))
      );
    }
  };

  useEffect(() => {
    dispatch(getAreas());
    dispatch(getCarpetas());
    dispatch(getAreasDescFicha());
  }, []);

  useEffect(
    () => getAEmployees(),
    [props.match.params.oType, props.match.params.searchtype]
  );

  useEffect(() => {
    dispatch(getJobPositions({}, parseInt(props.match.params.oType)));
    dispatch(getAreasJerarquia({}, parseInt(props.match.params.oType), true));
    dispatch(getEmployeesHierarchy(parseInt(props.match.params.oType)));
    dispatch(getPersonalDivision({}, parseInt(props.match.params.oType)));
    dispatch(getCurrentSituation({}, parseInt(props.match.params.oType)));
    dispatch(getCenterCost(parseInt(props.match.params.oType)));
    dispatch(getDivision({}, parseInt(props.match.params.oType)));
    dispatch(getAuroraDivision({}))
    dispatch(getEmploymentRel(parseInt(props.match.params.oType)));
    dispatch(getCivilState(parseInt(props.match.params.oType)));
    dispatch(getClassification({}, parseInt(props.match.params.oType)));
    dispatch(get_tasks({}, parseInt(props.match.params.oType)));
    dispatch(getCompanias({}, parseInt(props.match.params.oType)));
  }, [dispatch, props.match.params.oType]);

  // useEffect(() => {
  //   if(!employmentRelationLoader &&
  //      !divisionLoader &&
  //      !centerCostLoader &&
  //      !classificationLoader &&
  //      !classificationLoader &&
  //      !currentSituationLoader &&
  //      !loadingAreas &&
  //      !loadingAreas &&
  //      !employeesHierarchyLoader &&
  //      !loadingJobs &&
  //      !tasksLoader){
  //        setEditItem({...editItem});
  //      }
  // }, [employmentRelationLoader,
  //     divisionLoader,
  //     centerCostLoader,
  //     classificationLoader,
  //     currentSituationLoader,
  //     loadingAreas,
  //     employeesHierarchyLoader,
  //     loadingJobs,
  //     tasksLoader,
  //     editItem]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setEditItem({});
    //setLoadingType('modal');
    setValidated(false);
    setselectedPais([]);
    setSelectedDepartamento([]);
    setSelectedMunicipio([]);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    //setLoadingType('modal');
    setValidated(false);
    setEc(
      item.Estado_Civil_List && item.Estado_Civil_List.length > 0
        ? item.Estado_Civil_List[0].nombre
        : ""
    );

    //Paises, departamentos, municipios
    if (item.municipio) {
      setselectedPais([
        {
          ...item.list_municipio?.[0].list_departamento?.[0].list_pais?.[0],
          label:
            item.list_municipio[0].list_departamento[0].list_pais[0].nombre.toUpperCase(),
          item: item.list_municipio[0].list_departamento[0].list_pais[0].nombre.toUpperCase(),
        },
      ]);
      dispatch(
        getDepartamentUser(item.list_municipio[0].list_departamento[0].pais)
      );
      dispatch(getMunicipalityUser(item.list_municipio[0].departamento));
      setSelectedDepartamento([
        {
          ...item.list_municipio[0].list_departamento[0],
          label:
            item.list_municipio[0].list_departamento[0].nombre.toUpperCase(),
          item: item.list_municipio[0].list_departamento[0].nombre.toUpperCase(),
        },
      ]);
      setSelectedMunicipio([
        {
          ...item.list_municipio[0],
          label: item.list_municipio[0].nombre.toUpperCase(),
          item: item.list_municipio[0].nombre.toUpperCase(),
        },
      ]);
    } else {
      setselectedPais([]);
      setSelectedDepartamento([]);
      setSelectedMunicipio([]);
    }
  };

  const onModalMenu = (id, nombre) => {
    setemployeeId(id);
    setShowModalMenu(true);
    setemployeeName(nombre);
    // setValidated(false);
  };

  /*Paginación*/
  /*const prev = () => {
    if (currentPage <= 0)
      setCurrentPage(0);
    else
      setCurrentPage(currentPage - 1);

    setOffset(offset - limit);
  }

  const next = () => {
    if (currentPage >= pages)
      setCurrentPage(pages);
    else
      setCurrentPage(currentPage + 1);

    setOffset(offset + limit);
  }

  const last = () => {
    setCurrentPage(pages);
    setOffset((pages * limit) - limit);
  }

  const first = () => {
    setCurrentPage(1);
    setOffset(0);
  }

  const onChangeLimit = value => {
    setLimit(parseInt(value));
    setOffset(0);
    setCurrentPage(1);
  };*/

  const getGDReq = async (
    file,
    descripcion,
    sFechaEntrega,
    tipoDocumentoGD,
    tipoDocumento
  ) => {
    try {
      const filebase64 = await getBase64(file);
      const fileName = file.name;
      const fName = String(fileName)
        .substring(0, String(fileName).lastIndexOf("."))
        .replace(/\W/g, "");
      const fExt = `.${String(fileName).substr(
        fileName.lastIndexOf(".") + 1 - fileName.length
      )}`;
      const aFileBase = String(filebase64).split(",");
      const req = {
        id_area: gdAreas[0].id,
        id_carpeta_encabezado: carpetas.find(
          (item) => item.descripcion === estadoCivil.carpeta
        ).id,
        empresa: edit && editItem.empresa ? editItem.empresa[0] : "",
        zona:
          edit && editItem.Division_Personal_List
            ? editItem.Division_Personal_List[0].descripcion
            : "",
        tipo_documento_GD: tipoDocumentoGD,
        descripcion: descripcion,
        id_empleado: edit ? editItem.id : "",
        tipo_documento: tipoDocumento,
        archivo: aFileBase[1],
        fecha: moment(sFechaEntrega).format("YYYY-MM-DD"),
        origen: fName + fExt,
        extension: fExt,
        id_registro: 0,
        contentTypeGD: `${aFileBase[0]},`,
      };
      return { hasError: false, req: req };
    } catch (error) {
      toastr.info("Error al convertir archivo del gestor documental");
      //setEstadoCivilError(true);
      //setValidated(false);
      return { hasError: true, err: error };
    }
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (!e.target.filter.value.trim()) {
      return;
    }
    setSearch(false);
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAEmployees(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true)
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = new FormData();
    console.log("e", editItem)
    if (e.target.picFile.files.length > 0) {
      req.append("foto", e.target.picFile.files[0]);
    }

    let reqEstadoCivilGD = null;
    let reqCroquisGD = null;
    if (
      e.target.archivoEstadoCivil &&
      e.target.archivoEstadoCivil.files.length > 0
    ) {
      if (e.target.archivoEstadoCivil.files[0].size / 1024 > 200000) {
        //
        toastr.info("El archivo, sobrepasa el máximo admisible de 200 mb");
        setEstadoCivilError(true);
        setValidated(false);
        return;
      } else {
        setEstadoCivilError(false);
      }
      if (!e.target.fechaEntrega.value.trim()) {
        setfechaEntregaError(true);
        setValidated(false);
        return;
      } else {
        setfechaEntregaError(false);
      }
      if (carpetas.length === 0 || gdAreas.length === 0) {
        toastr.info(
          "Lo sentimos la información necesaria no realizar el registro no esta completa, por favor contacte con el administrador del sistema"
        );
        return;
      }
      reqEstadoCivilGD = await getGDReq(
        e.target.archivoEstadoCivil.files[0],
        estadoCivil.descripcion,
        e.target.fechaEntrega.value,
        estadoCivil.tipoDocumentoGD,
        estadoCivil.tipoDocumento
      );
      if (reqEstadoCivilGD.hasError) {
        toastr.error(
          "Lo sentimos hemos experimentado un error al subir el archivo de estado civil, por favor contacte con el administrador del sistema"
        );
        return;
      }
    }

    if (e.target.imagenCroquis && e.target.imagenCroquis.files.length > 0) {
      if (e.target.imagenCroquis.files[0].size / 1024 > 61440) {
        //
        toastr.info("El archivo, sobrepasa el máximo admisible de 60 mb");
        setCroquisError(true);
        setValidated(false);
        return;
      } else {
        setCroquisError(false);
      }
      if (carpetas.length === 0 || gdAreas.length === 0) {
        toastr.info(
          "Lo sentimos la información necesaria no realizar el registro no esta completa, por favor contacte con el administrador del sistema"
        );
        return;
      }
      reqCroquisGD = await getGDReq(
        e.target.imagenCroquis.files[0],
        domicilio.descripcion,
        moment().format("YYYY-MM-DD"),
        domicilio.tipoDocumentoGD,
        domicilio.tipoDocumento
      );
      if (reqCroquisGD.hasError) {
        toastr.error(
          "Lo sentimos hemos experimentado un error al subir el archivo, por favor contacte con el administrador del sistema"
        );
        return;
      }
    }
    if (selectedPais.length <= 0) {
      toastr.error("Debe ingresar un pais");
      return;
    }
    if (selectedDepartamento.length <= 0) {
      toastr.error("Debe ingresar un departamento");
      return;
    }
    if (selectedMunicipio.length <= 0) {
      toastr.error("Debe ingresar un municipio");
      return;
    }
    if (!editItem.centro_costo) {
      toastr.error("Debe ingresar un centro de costo");
      return;
    }
    if (!editItem.puesto?.[0]) {
      toastr.error("Debe ingresar un puesto");
      return;
    }
    if (!editItem.posicion?.[0]) {
      toastr.error("Debe ingresar una función");
      return;
    }
    if (!editItem.unidad_organizativa?.[0]) {
      toastr.error("Debe ingresar una unidad organizativa");
      return;
    }


    req.append("identidad", e.target.identidad.value);
    req.append("nombre", e.target.nombre.value);
    req.append("codigo", e.target.codigo.value);
    req.append("area", e.target.area.value);
    req.append(
      "fecha_ingreso",
      moment(e.target.fecha_ingreso.value).format("YYYY-MM-DD")
    );
    if (!!e.target.fecha_baja.value) {
      req.append(
        "fecha_baja",
        moment(e.target.fecha_baja.value).format("YYYY-MM-DD")
      );
    }
    req.append(
      "antiguedad_laboral",
      moment().diff(moment(e.target.fecha_ingreso.value), "months")
    );
    req.append("correo_empresarial", e.target.correo_empresarial.value);
    req.append("correo_personal", e.target.correo_personal.value);
    req.append(
      "fecha_cumpleaños",
      moment(e.target.fecha_cumpleaños.value).format("YYYY-MM-DD")
    );
    req.append(
      "edad",
      moment().diff(moment(e.target.fecha_cumpleaños.value), "years")
    );
    req.append("saldo_vacaciones", e.target.saldo_Vacaciones.value);
    req.append("absentismo", e.target.absentismo.value);
    req.append("domicilio", e.target.domicilio.value);
    // req.append('historial_laboral', e.target.historial_laboral.value);
    req.append("clasificacion_empleado", e.target.clasificacion.value);
    req.append("relacion_laboral", e.target.relacion_laboral.value);
    req.append("division", e.target.division.value);
    req.append("centro_costo", editItem.centro_costo);
    req.append("estado_civil", e.target.estado_civil.value);
    req.append("puesto", editItem.puesto[0]);
    req.append("posicion", editItem.posicion[0]);
    // req.append('unidad_organizativa', [parseInt(e.target.unidad_organizativa.value)]);
    req.append("unidad_organizativa", editItem.unidad_organizativa[0]);

    if (editItem.Division_Aurora_List?.[0]?.id) {
      req.append("division_aurora", editItem.Division_Aurora_List[0].id);
    }

    if (editItem?.empresa_id?.[0]) {
      req.append("empresa", editItem.empresa_id[0]);
    }
    // req.append('situacion_actual', [parseInt(e.target.situacion_actual.value)]);
    req.append("situacion_actual", e.target.situacion_actual.value);
    req.append("genero", e.target.genero.value);
    req.append("telefono", e.target.telefono.value);
    req.append("tipo_sangre", e.target.tipo_sangre.value);
    req.append("division_personal", e.target.division_personal.value);
    req.append("jefe_inmediato", e.target.jefe_inmediato.value);
    req.append("celular", e.target.celular.value);
    req.append("clase_medida", e.target.claseMedida.value);
    req.append(
      "descripcion_clase_medida",
      e.target.descripcionClaseMedida.value
    );
    req.append("motivo_clase_medida", e.target.motivoClaseMedida.value);
    req.append(
      "descripcion_motivo_clase_medida",
      e.target.descripcionMotivoClaseMedida.value
    );
    req.append("es_jefe", e.target.esJefe.checked);
    // req.append('pais', selectedPais[0].id);
    // req.append('departamento',selectedDepartamento[0].id );
    req.append("municipio", selectedMunicipio[0].id);

    for (var pair of req.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    // const _existPais = paises.find(
    //   (f) => f.name_es === parseInt(req.name_es)
    // );

    dispatch(getEmployeesHierarchy(parseInt(props.match.params.oType)));
    console.log(req)
    if (!edit) {
      dispatch(
        saveEmployee(
          req,
          parseInt(props.match.params.oType),
          reqEstadoCivilGD && reqEstadoCivilGD.req
            ? reqEstadoCivilGD.req
            : null,
          reqCroquisGD && reqCroquisGD.req ? reqCroquisGD.req : null
        )
      );
      e.target.reset();
      setShowModal(false);
    } else {
      dispatch(
        editEmployee(
          req,
          editItem,
          index,
          parseInt(props.match.params.oType),
          reqEstadoCivilGD && reqEstadoCivilGD.req
            ? reqEstadoCivilGD.req
            : null,
          reqCroquisGD && reqCroquisGD.req ? reqCroquisGD.req : null,
          editItem.croquis
        )
      );
      setShowModal(false);
    }
    setIsSubmitted(false);
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    setSearch(true);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getAEmployees(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteEmployee(id, index, parseInt(props.match.params.oType)));
    }
  };

  const onCloseModal = () => {
    setShowModal(false);
    setIsSubmitted(false)
  }
  const { genero } = config.aurora;

  const onShowSidebar = () => setShow(show ? false : true);

  const onChangeImg = (e) => {
    imgRef.current.src = URL.createObjectURL(e.target.files[0]);
  };

  const onChangeEstadoCivil = (e) => {
    const estadoCivilUsuario = civilState.find(
      (item) => item.id === parseInt(e.target.value)
    );
    setEc(estadoCivilUsuario.nombre);
  };

  const { deptos } = config.aurora; //Falta cargar municipios y traer la informacion de la API

  const [paisesTransform, setPaisesTransform] = useState([]);
  const [selectedPais, setselectedPais] = useState([]);

  const [departamentosTransform, setDepartamentosTransform] = useState([]);
  const [selectedDepartamento, setSelectedDepartamento] = useState([]);

  const [municipiosTransform, setMunicipiosTransform] = useState([]);
  const [selectedMunicipio, setSelectedMunicipio] = useState([]);

  useEffect(() => {
    dispatch(getCountryUser());
  }, [dispatch]);

  const handleSelectPais = (selected) => {
    if (selected.length > 0) {
      setselectedPais(selected);
      setDepartamentosTransform([]);
      setSelectedDepartamento([]);
      dispatch(getDepartamentUser(selected[0].id));
    } else {
      setselectedPais([]);
      setDepartamentosTransform([]);
      setSelectedDepartamento([]);
    }
  };
  const handleSelectDepartment = (selected) => {
    if (selected.length > 0) {
      setSelectedDepartamento(selected);
      setMunicipiosTransform([]);
      setSelectedMunicipio([]);
      dispatch(getMunicipalityUser(selected[0].id));
    } else {
      setSelectedDepartamento([]);
      setMunicipiosTransform([]);
      setSelectedMunicipio([]);
    }
  };

  const countries = useSelector((store) => store.countryUser.countryUser);
  const departments = useSelector(
    (store) => store.departamentUser.departamentUser
  );
  const municipalities = useSelector(
    (store) => store.municipalityUser.municipalityUser
  );


  useEffect(() => {
    !!countries &&
      setPaisesTransform(
        countries.data.map((pais) => ({
          ...pais,
          label: pais.nombre.toUpperCase(),
          item: pais.nombre.toUpperCase(),
        }))
      );
  }, [countries]);

  useEffect(() => {
    !!departments &&
      departments.data.length > 0 &&
      setDepartamentosTransform(
        departments.data.map((dep) => ({
          ...dep,
          label: dep.nombre.toUpperCase(),
          item: dep.nombre.toUpperCase(),
        }))
      );
  }, [departments]);

  useEffect(() => {
    console.log(municipalities);
    !!municipalities &&
      municipalities.data.length > 0 &&
      setMunicipiosTransform(
        municipalities.data.map((municipio) => ({
          ...municipio,
          label: municipio.nombre.toUpperCase(),
          item: municipio.nombre.toUpperCase(),
        }))
      );
  }, [municipalities]);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        {console.log(data)}
        <div className="container-fluid">
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="font-weight-bold text-uppercase">
              {props.match.params.name}:{" "}
              {props.match.params.oType === 1 ? "Formal" : "Funcional"}{" "}
              Empleados
            </h5>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    defaultValue={filter}
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">visibility</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <Dropdown className="mx-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {areasError || carpetasError ? (
            <Alert variant="danger">
              {areasError && areasError}
              {carpetasError && carpetasError}
            </Alert>
          ) : null}
          {loading || loadingGDAreas || loadingCarpetas ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={dataLenght}
                pages={pages}
                pagFunc={getAEmployees}
              />
            </>
          ) : !Search && filter !== "" ? (
            <Alert variant="info" className="my-4">
              Empleado no encontrado
            </Alert>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay empleados registrados, comienza agregando algunos
            </Alert>
          )}
        </div>
      </div>
      <Modal show={showModal} size="lg" onHide={onCloseModal}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title>
              {edit ? "Editar ficha empleado" : "Crear ficha empleado"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col sm={12} md={3} className="text-center">
                <img
                  ref={imgRef}
                  src={
                    edit && editItem.foto
                      ? `${process.env.REACT_APP_URL}/media/${editItem.foto}`
                      : perfilImage
                  }
                  className="image-employe-modal rounded"
                  alt="foto de perfil"
                />
                <Form.Group controlId="picFile" className="mt-2 text-left">
                  <Form.Label>Seleccione foto de perfil</Form.Label>
                  <Form.Control
                    // required={!edit}
                    onChange={onChangeImg}
                    name="picFile"
                    type="file"
                    accept=".jpeg, .jpg, .png"
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={9}>
                <Row className="mb-2">
                  <Form.Group as={Col} controlId="nombre">
                    <Form.Label className="ml-2">Nombre</Form.Label>
                    <Form.Control
                      name="nombre"
                      required
                      disabled={
                        edit && parseInt(props.match.params.oType) === 1
                      }
                      type="text"
                      placeholder="Nombre"
                      pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                      className="rounded-pill"
                      defaultValue={edit ? editItem.nombre : null}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite letras
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="Identidad">
                    <Form.Label className="ml-2">Identidad</Form.Label>
                    <Form.Control
                      name="identidad"
                      className="rounded-pill"
                      required
                      disabled={
                        edit && parseInt(props.match.params.oType) === 1
                      }
                      type="text"
                      pattern="[0-9]{13}"
                      defaultValue={edit ? editItem.identidad : null}
                      placeholder="Identidad"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite una cadena de números de longitud13
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="codigo">
                    <Form.Label className="ml-2">Código</Form.Label>
                    <Form.Control
                      name="codigo"
                      className="rounded-pill"
                      required
                      disabled={
                        edit && parseInt(props.match.params.oType) === 1
                      }
                      type="text"
                      defaultValue={edit ? editItem.codigo : null}
                      pattern="[0-9]+"
                      placeholder="Código"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group as={Col} controlId="fecha_ingreso">
                    <Form.Label className="ml-2">Fecha ingreso</Form.Label>
                    <Form.Control
                      name="fecha_ingreso"
                      className="rounded-pill"
                      disabled={
                        edit && parseInt(props.match.params.oType) === 1
                      }
                      required
                      min={moment("1910-01-01").format("YYYY-MM-DD")}
                      max={moment().format("YYYY-MM-DD")}
                      type="date"
                      defaultValue={edit ? editItem.fecha_ingreso : null}
                      placeholder="Fecha_ingreso"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <ul className="list-unstyled">
                        <li>**Fecha no valida</li>
                        <li>
                          **El rango de fecha valida es 1910 a fecha actual
                        </li>
                      </ul>
                    </Form.Control.Feedback>
                  </Form.Group>
                  {/* <Form.Group as={Col} controlId="antiguedad_laboral">
                    <Form.Label className="ml-2">Antigüedad laboral</Form.Label>
                    <Form.Control
                      name="antiguedad_laboral"
                      className="rounded-pill"
                      required
                      type="text"
                      pattern="[0-9]+"
                      defaultValue={edit ? parseInt(editItem.antiguedad_laboral) : null}
                      placeholder="Antigüedad laboral"></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números enteros
                    </Form.Control.Feedback>
                  </Form.Group> */}
                  <Form.Group as={Col} controlId="correo_empresarial">
                    <Form.Label className="ml-2">Correo empresarial</Form.Label>
                    <Form.Control
                      name="correo_empresarial"
                      className="rounded-pill"
                      required
                      type="email"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      defaultValue={edit ? editItem.correo_empresarial : null}
                      placeholder="Correo empresarial"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Se requiere un correo valido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <Row className="mb-2">
                  <Form.Group as={Col} controlId="correo_personal">
                    <Form.Label className="ml-2">Correo personal</Form.Label>
                    <Form.Control
                      name="correo_personal"
                      className="rounded-pill"
                      required
                      type="email"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                      defaultValue={edit ? editItem.correo_personal : null}
                      placeholder="Correo personal"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Se requiere un correo valido
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} controlId="fecha_cumpleaños">
                    <Form.Label className="ml-2">
                      Fecha de nacimiento
                    </Form.Label>
                    <Form.Control
                      name="fecha_cumpleaños"
                      className="rounded-pill"
                      min={moment("1910-01-01").format("YYYY-MM-DD")}
                      max={moment().format("YYYY-MM-DD")}
                      required
                      disabled={
                        edit && parseInt(props.match.params.oType) === 1
                      }
                      type="date"
                      defaultValue={edit ? editItem.fecha_cumpleaños : null}
                      placeholder="Fecha de cumpleaños"
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      <ul className="list-unstyled">
                        <li>**Fecha no valida</li>
                        <li>
                          **El rango de fecha valida es 1910 a fecha actual
                        </li>
                      </ul>
                    </Form.Control.Feedback>
                  </Form.Group>
                  {/*  <Form.Group as={Col} controlId="edad">
                    <Form.Label className="ml-2">Edad</Form.Label>
                    <Form.Control
                      name="edad"
                      className="rounded-pill"
                      required
                      type="number"
                      pattern="[0-9]+"
                      defaultValue={edit ? parseInt(editItem.edad) : null}
                      placeholder="Edad"></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Número entero requerido
                    </Form.Control.Feedback>
                    <Form.Control.Feedback type="invalid">
                      **Solo admite números enteros
                    </Form.Control.Feedback>
                  </Form.Group> */}
                </Row>
              </Col>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="estado_civil">
                <Row className="align-items-end">
                  <Col sm={civilStateLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Estado civil</Form.Label>
                    <Form.Control
                      as="select"
                      name="estado_civil"
                      className="rounded-pill"
                      required
                      onChange={onChangeEstadoCivil}
                      defaultValue={edit ? editItem.estado_civil : null}
                    >
                      {civilState
                        ? civilState
                          .sort((a, b) => {
                            if (a.nombre && b.nombre) {
                              if (
                                a.nombre.toLowerCase() ===
                                b.nombre.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.nombre.toLowerCase() <
                                b.nombre.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item, index) => (
                            <option
                              key={item.id ? item.id : index}
                              value={item.id ? item.id : ""}
                            >
                              {item.nombre ? item.nombre.toUpperCase() : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {civilStateLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="genero">
                <Form.Label className="ml-2">Género</Form.Label>
                <Form.Control
                  as="select"
                  name="genero"
                  className="rounded-pill"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  defaultValue={edit ? editItem.genero : null}
                >
                  {genero.map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.nombre}
                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="tipo_sangre">
                <Form.Label className="ml-2">Tipo de sangre</Form.Label>
                <Form.Control
                  as="select"
                  name="tipo_sangre"
                  className="rounded-pill"
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  required
                  defaultValue={edit ? editItem.tipo_sangre : null}
                >
                  <option value="A+">A+</option>
                  <option value="B+">B+</option>
                  <option value="O+">O+</option>
                  <option value="AB+">AB+</option>
                  <option value="A-">A-</option>
                  <option value="B-">B-</option>
                  <option value="O-">O-</option>
                  <option value="AB-">AB-</option>
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="celular">
                <Form.Label className="ml-2">Celular</Form.Label>
                <Form.Control
                  name="celular"
                  className="rounded-pill"
                  required
                  type="tel"
                  defaultValue={edit ? editItem.celular : null}
                  placeholder="Celular"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un teléfono válido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="telefono">
                <Form.Label className="ml-2">Teléfono</Form.Label>
                <Form.Control
                  name="telefono"
                  className="rounded-pill"
                  required
                  type="tel"
                  defaultValue={edit ? editItem.telefono : null}
                  placeholder="Teléfono"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Se requiere un número de celular válido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="pais">
                <Row className="align-items-end">
                  <Col sm={countryLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">País</Form.Label>
                    <Typeahead
                      id="pais"
                      name="pais"
                      // isInvalid={touched.responsable && errors.responsable}
                      // isValid={touched.responsable && !errors.responsable}
                      // onBlur={handleBlur("responsable")}
                      placeholder="Seleccione un país"
                      options={paisesTransform}
                      onChange={(selected) => {
                        handleSelectPais(selected);
                      }}
                      selected={selectedPais}
                      disabled={
                        !!paisesTransform == false
                        // || specializationsLoading
                      }
                    ></Typeahead>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {countryLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="departamento">
                <Form.Label className="ml-2">Departamento</Form.Label>
                <Typeahead
                  id="departamento"
                  name="departamento"
                  // isInvalid={selectedDepartamento.length <= 0}
                  // isValid={touched.responsable && !errors.responsable}
                  // onBlur={handleBlur("responsable")}
                  placeholder="Seleccione un departamento"
                  options={departamentosTransform}
                  onChange={(selected) => {
                    console.log(selected);
                    handleSelectDepartment(selected);
                    // setEditItem({
                    //   ...editItem,
                    //   especialidad: selected.length > 0 ? selected[0].id : "",
                    // })
                  }}
                  selected={selectedDepartamento}
                  disabled={
                    !!departamentosTransform == false ||
                    departamentosTransform.length == 0 ||
                    !!selectedPais.length > 0 == false
                    // || specializationsLoading
                  }
                ></Typeahead>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="municipio">
                <Form.Label className="ml-2">Municipio</Form.Label>
                <Typeahead
                  id="municipio"
                  name="municipio"
                  // isInvalid={touched.responsable && errors.responsable}
                  // isValid={touched.responsable && !errors.responsable}
                  // onBlur={handleBlur("responsable")}
                  placeholder="Seleccione un Municipio"
                  options={municipiosTransform}
                  onChange={(selected) => {
                    console.log(selected);
                    setSelectedMunicipio(selected);
                    // setEditItem({
                    //   ...editItem,
                    //   especialidad: selected.length > 0 ? selected[0].id : "",
                    // })
                  }}
                  selected={selectedMunicipio}
                  disabled={
                    !!municipiosTransform == false ||
                    !!selectedDepartamento.length > 0 == false
                    // || specializationsLoading
                  }
                ></Typeahead>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Form.Group controlId="domicilio">
              <Form.Label className="ml-2">Domicilio</Form.Label>
              <Form.Control
                as="textarea"
                name="domicilio"
                required
                defaultValue={edit ? editItem.domicilio : null}
                placeholder="Domicilio"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
            </Form.Group>
            {/* <Form.Group controlId="historial_laboral">
              <Form.Label className="ml-2">Historial laboral</Form.Label>
              <Form.Control
                as="textarea"
                name="historial_laboral"
                required
                disabled
                defaultValue={ edit ? 
                                editItem.Historial_Laboral_List ?
                                editItem.Historial_Laboral_List.map((item,index) => {
                                  return item.descripcion
                                }) : 'No tiene'
                              : null 
                              }
                pattern="[A-Za-z0-9]+"
                placeholder="Historial laboral"></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite números y letras
              </Form.Control.Feedback>
            </Form.Group> */}
            <Row>
              <Form.Group as={Col} controlId="saldo_Vacaciones">
                <Form.Label className="ml-2">Saldo vacaciones</Form.Label>
                <Form.Control
                  name="saldo_Vacaciones"
                  className="rounded-pill"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  type="number"
                  pattern="[0-9]+"
                  defaultValue={
                    edit ? parseInt(editItem.saldo_vacaciones) : null
                  }
                  placeholder="Saldo vacaciones"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Número entero requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Campo obligatorio
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="absentismo">
                <Form.Label className="ml-2">Absentismo</Form.Label>
                <Form.Control
                  name="absentismo"
                  className="rounded-pill"
                  required
                  type="number"
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  pattern="[0-9]+"
                  defaultValue={edit ? parseInt(editItem.absentismo) : null}
                  placeholder="Absentismo"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Número entero requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Campo obligatorio
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="relacion_laboral">
                <Row className="align-items-end">
                  <Col sm={employmentRelationLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Relación laboral</Form.Label>
                    <Form.Control
                      as="select"
                      name="relacion_laboral"
                      className="rounded-pill"
                      required
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        employmentRelationLoader
                      }
                      value={
                        edit &&
                          editItem.relacion_laboral &&
                          employmentRelationLoader === false
                          ? editItem.relacion_laboral
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          relacion_laboral: e.target.value,
                        })
                      }
                      placeholder="Relación laboral"
                    >
                      {employmentRelation
                        ? employmentRelation
                          .sort((a, b) => {
                            if (a.descripcion && b.descripcion) {
                              if (
                                a.descripcion.toLowerCase() ===
                                b.descripcion.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.descripcion.toLowerCase() <
                                b.descripcion.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.id ? item.id : ""}
                            >
                              {item.descripcion
                                ? item.descripcion.toUpperCase()
                                : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {employmentRelationLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="division">
                <Row className="align-items-end">
                  <Col sm={divisionLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">División</Form.Label>
                    <Form.Control
                      as="select"
                      name="division"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        divisionLoader
                      }
                      className="rounded-pill"
                      required
                      value={
                        edit && editItem.division && divisionLoader === false
                          ? editItem.division
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({ ...editItem, division: e.target.value })
                      }
                    >
                      {division
                        ? division
                          .sort((a, b) => {
                            if (a.descripcion && b.descripcion) {
                              if (
                                a.descripcion.toLowerCase() ===
                                b.descripcion.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.descripcion.toLowerCase() <
                                b.descripcion.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.id ? item.id : ""}
                            >
                              {item.descripcion
                                ? item.descripcion.toUpperCase()
                                : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {divisionLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Col>
                <Row className="align-items-end"> {/* Se coloca el estilo del typeahead para valid o invalid  */}
                  <Col sm={centerCostLoader ? "10" : "12"} className={isSubmitted ? !editItem.centro_costo ? "tph-isInvalid" : "tph-isvalid" : ""}>
                    <Form.Label className="ml-2">Centro de costo</Form.Label>
                    <Typeahead
                      id="centro_costo"
                      name="centro_costo"
                      required
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        centerCostLoader
                      }
                      options={centerCostOptions}
                      value={
                        edit &&
                          editItem.centro_costo &&
                          centerCostLoader === false
                          ? editItem.centro_costo
                          : null
                      }
                      onChange={(selected) => {
                        setEditItem({
                          ...editItem,
                          centro_costo: selected[0]?.id,
                        })
                        console.log(selected[0]?.id)
                      }
                      }
                      defaultInputValue={
                        edit && editItem.centro_costo && centerCostLoader === false
                          ? centerCostOptions.filter(option => option.id == editItem.centro_costo)[0]?.label : ""}
                      placeholder="Centro de Costo"

                    />
                    {console.log("ca", validated)}
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {centerCostLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>

            </Row>
            <Row>
              {/* <Form.Group as={Col} controlId="clasificacion">
                <Form.Label className="ml-2">Clasificación</Form.Label>
                <Form.Control
                  name="clasificacion"
                  className="rounded-pill"
                  required
                  type="text"
                  defaultValue={edit ? editItem.clasificacion : null}
                  pattern="[A-Za-z0-9]+"
                  placeholder="Clasificación"></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite números y letras
                </Form.Control.Feedback>
              </Form.Group> */}
              <Form.Group as={Col} controlId="area">
                <Row className="align-items-end">
                  <Col sm={loadingAreasDesc ? "10" : "12"}>
                    <Form.Label className="ml-2">Área</Form.Label>
                    <Form.Control
                      as="select"
                      id="area"
                      name="area"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        loadingAreasDesc
                      }
                      className="rounded-pill"
                      // required
                      value={
                        edit &&
                          editItem.list_area_descriptores &&
                          editItem.list_area_descriptores[0]
                          ? editItem.list_area_descriptores[0]
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          area: e.target.value,
                        })
                      }
                      placeholder="Área"
                    >
                      <option value="" selected disabled></option>
                      {areasDesc
                        ? areasDesc.data.map((item) => (
                          <option
                            key={item.id}
                            value={item.id ? item.id : ""}
                          >
                            {item.descripcion
                              ? item.descripcion.toUpperCase()
                              : ""}
                          </option>
                        ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {loadingAreasDesc && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="clasificacion">
                <Row className="align-items-end">
                  <Col sm={classificationLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Clasificación</Form.Label>
                    <Form.Control
                      as="select"
                      id="clasificacion"
                      name="clasificacion"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        classificationLoader
                      }
                      className="rounded-pill"
                      required
                      value={
                        edit &&
                          editItem.clasificacion_empleado &&
                          classificationLoader === false
                          ? editItem.clasificacion_empleado
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          clasificacion_empleado: e.target.value,
                        })
                      }
                      placeholder="Clasificación"
                    >
                      {classification
                        ? classification
                          .sort((a, b) => {
                            if (a.nombre && b.nombre) {
                              if (
                                a.nombre.toLowerCase() ===
                                b.nombre.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.nombre.toLowerCase() <
                                b.nombre.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.id ? item.id : ""}
                              selected
                            >
                              {item.nombre ? item.nombre.toUpperCase() : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {classificationLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
              <Form.Group as={Col} controlId="situacion_actual">
                <Row className="align-items-end">
                  <Col sm={currentSituationLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Situacion actual</Form.Label>
                    <Form.Control
                      as="select"
                      id="situacion_actual"
                      name="situacion_actual"
                      className="rounded-pill"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        currentSituationLoader
                      }
                      required
                      value={
                        edit &&
                          editItem.situacion_actual &&
                          currentSituationLoader === false
                          ? editItem.situacion_actual
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          situacion_actual: e.target.value,
                        })
                      }
                      placeholder="Situacion actual"
                    >
                      {currentSituation
                        ? currentSituation
                          .sort((a, b) => {
                            if (a.descripcion && b.descripcion) {
                              if (
                                a.descripcion.toLowerCase() ===
                                b.descripcion.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.descripcion.toLowerCase() <
                                b.descripcion.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.id ? item.id : ""}
                            >
                              {item.descripcion
                                ? item.descripcion.toUpperCase()
                                : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {currentSituationLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Col>
                <Row className="align-items-end"> {/* Se coloca el estilo del typeahead para valid o invalid  */}
                  <Col sm={loadingAreas ? "10" : "12"} className={isSubmitted ? !editItem.unidad_organizativa ? "tph-isInvalid" : "tph-isvalid" : ""}>
                    <Form.Label className="ml-2">
                      Unidad organizativa
                    </Form.Label>
                    <Typeahead
                      id="unidad_organizativa"
                      name="unidad_organizativa"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        loadingAreas
                      }
                      options={unidadesOrganizativasOptions}
                      required
                      value={
                        edit &&
                          editItem.unidad_organizativa &&
                          loadingAreas === false
                          ? editItem.unidad_organizativa[0]
                          : null
                      }
                      onChange={(selected) => {
                        setEditItem({
                          ...editItem,
                          unidad_organizativa: [selected[0]?.id],
                        })
                        console.log([selected[0]?.id])
                      }

                      }
                      defaultInputValue={
                        edit && editItem.unidad_organizativa && loadingAreas === false
                          ? unidadesOrganizativasOptions.filter(option => option.id == editItem.unidad_organizativa[0])[0]?.label : ""}

                      placeholder="Unidad organizativa"
                    />

                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {loadingAreas && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
              {parseInt(props.match.params.oType) !== 1 && (
                <Col>
                  <Row className="align-items-end">
                    <Col sm={auroraDivisionLoader ? "10" : "12"}>
                      <Form.Label className="ml-2">
                        Division Aurora
                      </Form.Label>
                      <Typeahead
                        id="division_aurora"
                        name="division_aurora"
                        disabled={

                          auroraDivisionLoader
                        }
                        options={auroraDivisionOptions}
                        required
                        value={
                          edit &&
                            editItem.Division_Aurora_List &&
                            auroraDivisionLoader === false
                            ? editItem.Division_Aurora_List?.[0]?.id
                            : null
                        }
                        onChange={(selected) => {
                          setEditItem({
                            ...editItem,
                            Division_Aurora_List: [selected?.[0]?.item],
                          })
                          console.log(selected[0])
                        }

                        }
                        defaultInputValue={
                          edit && editItem.Division_Aurora_List && auroraDivisionLoader === false
                            ? auroraDivisionOptions.filter(option => option.id == editItem.Division_Aurora_List?.[0]?.id)[0]?.label : ""}

                        placeholder="División Aurora"
                      />

                      <Form.Control.Feedback type="invalid">
                        **Campo requerido
                      </Form.Control.Feedback>
                    </Col>
                    {auroraDivisionLoader && (
                      <Col sm="2">
                        <Spinner animation="border" size="sm" />
                      </Col>
                    )}
                  </Row>
                </Col>
              )}

              <Form.Group as={Col} controlId="jefe_inmediato">
                <Row className="align-items-end">
                  <Col sm={employeesHierarchyLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">Jefe inmediato</Form.Label>
                    <Form.Control
                      as="select"
                      id="jefe_inmediato"
                      name="jefe_inmediato"
                      className="rounded-pill"
                      // required
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        employeesHierarchyLoader
                      }
                      value={
                        edit &&
                          editItem.jefe_inmediato &&
                          employeesHierarchyLoader === false
                          ? editItem.jefe_inmediato
                          : null
                      }
                      onChange={(e) =>
                        setEditItem({
                          ...editItem,
                          jefe_inmediato: e.target.value,
                        })
                      }
                      placeholder="Jefe inmediato"
                    >
                      <option value="">Ninguno</option>
                      {employeesHierarchy
                        ? employeesHierarchy
                          .sort((a, b) => {
                            if (a.nombre && b.nombre) {
                              if (
                                a.nombre.toLowerCase() ===
                                b.nombre.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.nombre.toLowerCase() <
                                b.nombre.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.codigo ? item.codigo : ""}
                            >
                              {item.nombre ? item.nombre.toUpperCase() : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {employeesHierarchyLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Col>
                <Row className="align-items-end"> {/* Se coloca el estilo del typeahead para valid o invalid  */}
                  <Col sm={loadingJobs ? "10" : "12"} className={isSubmitted ? !editItem.puesto ? "tph-isInvalid" : "tph-isvalid" : ""}>
                    <Form.Label className="ml-2">Puesto</Form.Label>
                    <Typeahead
                      id="puesto"
                      name="puesto"
                      required
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        loadingJobs
                      }
                      options={jobsOptions}
                      value={
                        edit && editItem.puesto && loadingJobs === false
                          ? editItem.puesto[0]
                          : null
                      }
                      onChange={(selected) => {
                        setEditItem({ ...editItem, puesto: [selected[0]?.id] })
                        console.log([selected[0]?.id])
                      }

                      }
                      placeholder="Puesto"
                      defaultInputValue={
                        edit && editItem.puesto && loadingJobs === false
                          ? jobsOptions.filter(option => option.id == editItem.puesto[0])[0]?.label : ""}

                    />
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {loadingJobs && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
              <Col>
                <Row className="align-items-end"> {/* Se coloca el estilo del typeahead para valid o invalid  */}
                  <Col sm={tasksLoader ? "10" : "12"} className={isSubmitted ? !editItem.posicion ? "tph-isInvalid" : "tph-isvalid" : ""}>
                    <Form.Label className="ml-2">Función</Form.Label>
                    <Typeahead
                      id="funcion"
                      name="funcion"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        tasksLoader
                      }
                      required={!edit}
                      options={tasksOptions}
                      value={
                        edit && editItem.posicion && tasksLoader === false
                          ? editItem.posicion[0]
                          : null
                      }
                      onChange={(selected) => {
                        setEditItem({ ...editItem, posicion: [selected[0]?.id] })
                        console.log([selected[0]?.id])
                      }

                      }
                      defaultInputValue={
                        edit && editItem.posicion && tasksLoader === false
                          ? tasksOptions.filter(option => option.id == editItem.posicion[0])[0]?.label : ""}

                      placeholder="Función"
                    />

                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {tasksLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
              <Col>
                <Row className="align-items-end"> {/* Se coloca el estilo del typeahead para valid o invalid  */}
                  <Col sm={companiaLoader ? "10" : "12"} className={isSubmitted ? !editItem.empresa_id ? "tph-isInvalid" : "tph-isvalid" : ""}>
                    <Form.Label className="ml-2">Empresa</Form.Label>
                    <Typeahead
                      id="empresa"
                      name="empresa"
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        companiaLoader
                      }
                      required={!edit}
                      options={companiesOptions}
                      value={
                        edit && editItem.empresa_id && companiaLoader === false
                          ? editItem.empresa_id[0]
                          : null
                      }
                      onChange={(selected) => {
                        setEditItem({ ...editItem, empresa_id: [selected[0]?.id] })
                        console.log([selected[0]?.id])
                      }

                      }
                      defaultInputValue={
                        edit && editItem.empresa_id && companiaLoader === false
                          ? companiesOptions.filter(option => option.id == editItem.empresa_id[0])[0]?.label : ""}

                      placeholder="Empresa"
                    />

                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {companiaLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="fecha_baja">
                <Form.Label className="ml-2">Fecha de baja</Form.Label>
                <Form.Control
                  name="fecha_baja"
                  className="rounded-pill"
                  //required={!edit}
                  type="date"
                  defaultValue={edit ? editItem.fecha_baja : null}
                  placeholder="Fecha de baja"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="division_personal">
                <Row className="align-items-end">
                  <Col sm={personalDivisionLoader ? "10" : "12"}>
                    <Form.Label className="ml-2">División personal</Form.Label>
                    <Form.Control
                      as="select"
                      id="division_personal"
                      name="division_personal"
                      className="rounded-pill"
                      required
                      disabled={
                        (edit && parseInt(props.match.params.oType) === 1) ||
                        personalDivisionLoader
                      }
                      defaultValue={
                        edit &&
                          editItem.division_personal &&
                          personalDivisionLoader === false
                          ? editItem.division_personal
                          : null
                      }
                      placeholder="División personal"
                    >
                      {personalDivision
                        ? personalDivision
                          .sort((a, b) => {
                            if (a.descripcion && b.descripcion) {
                              if (
                                a.descripcion.toLowerCase() ===
                                b.descripcion.toLowerCase()
                              ) {
                                return 0;
                              }
                              if (
                                a.descripcion.toLowerCase() <
                                b.descripcion.toLowerCase()
                              ) {
                                return -1;
                              }
                            }
                            return 1;
                          })
                          .map((item) => (
                            <option
                              key={item.id}
                              value={item.id ? item.id : ""}
                            >
                              {item.descripcion
                                ? item.descripcion.toUpperCase()
                                : ""}
                            </option>
                          ))
                        : null}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Col>
                  {personalDivisionLoader && (
                    <Col sm="2">
                      <Spinner animation="border" size="sm" />
                    </Col>
                  )}
                </Row>
              </Form.Group>
            </Row>
            <Row className="mb-2">
              <Form.Group as={Col} controlId="claseMedida">
                <Form.Label className="ml-2">Clase medida</Form.Label>
                <Form.Control
                  name="claseMedida"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  type="text"
                  placeholder="Clase Medida"
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+"
                  className="rounded-pill"
                  defaultValue={edit ? editItem.clase_medida : null}
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  **Solo admite letras
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="descripcionClaseMedida">
                <Form.Label className="ml-2">
                  Descripción clase medida
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="descripcionClaseMedida"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  defaultValue={edit ? editItem.descripcion_clase_medida : null}
                  placeholder="Descripción clase medida"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row>
              <Form.Group as={Col} controlId="motivoClaseMedida">
                <Form.Label className="ml-2">Motivo clase medida</Form.Label>
                <Form.Control
                  name="motivoClaseMedida"
                  className="rounded-pill"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  type="text"
                  defaultValue={edit ? editItem.motivo_clase_medida : null}
                  pattern="[A-Za-zñÑáéíóúÁÉÍÓÚ0-9\s]+}"
                  placeholder="Motivo clase medida"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} controlId="descripcionMotivoClaseMedida">
                <Form.Label className="ml-2">
                  Descripcion motivo clase medida
                </Form.Label>
                <Form.Control
                  as="textarea"
                  name="descripcionMotivoClaseMedida"
                  required
                  disabled={edit && parseInt(props.match.params.oType) === 1}
                  defaultValue={
                    edit ? editItem.descripcion_motivo_clase_medida : null
                  }
                  placeholder="Descripcion motivo clase medida"
                ></Form.Control>
                <Form.Control.Feedback type="invalid">
                  **Campo requerido
                </Form.Control.Feedback>
              </Form.Group>
            </Row>
            <hr />
            <ListGroup variant="flush">
              <ListGroup.Item className="d-flex justify-content-between aling-items-center">
                <label>¿Es jefe?</label>
                <Form.Check
                  defaultChecked={editItem.es_jefe}
                  type="switch"
                  name="esJefe"
                  id="esJefe"
                />
              </ListGroup.Item>
            </ListGroup>
            {ec.toLowerCase() === "viudo" ||
              ec.toLowerCase() === "cas." ||
              ec.toLowerCase() === "divor." ? (
              <>
                <hr />
                <p className="pl-2 text-muted form-text">
                  Apartado de acta de estado civil
                </p>
                <hr />
                <Row>
                  <Form.Group as={Col} className="mt-2 text-left">
                    <Form.File
                      className={estadoCivilError ? `is-invalid` : ""}
                      id="archivoEstadoCivil"
                    >
                      <Form.File.Label>
                        Archivo de estado civil{" "}
                      </Form.File.Label>
                      <Form.File.Input
                        required={
                          edit &&
                          editItem.estado_civil_archivo &&
                          editItem.estado_civil_archivo.length === 0
                        }
                        accept="image/*,application/pdf,.xlsx,.xls,.csv,.doc,.docx"
                        name="archivoEstadoCivil"
                        onChange={(e) =>
                          setIsReqDateFieldFileGD(
                            e.target.files.length > 0 ? true : false
                          )
                        }
                      />
                    </Form.File>
                    <small>Peso máximo permitido 200 megabytes</small>
                    <Form.Control.Feedback type="invalid">
                      <ul className="list-unstyled">
                        <li>**Es requerido un archivo de menor peso.</li>
                        <li>
                          **Es requerido un archivo con formato pdf o imagen.
                        </li>
                      </ul>
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Col} className="mt-2" id="fechaEntrega">
                    <Form.Label>Fecha de entrega</Form.Label>
                    <Form.Control
                      disabled={!isReqDateFieldFileGD}
                      required={isReqDateFieldFileGD}
                      className={`rounded-pill ${fechaEntregaError ? "is-invalid" : ""
                        }`}
                      type="date"
                      name="fechaEntrega"
                    ></Form.Control>
                    <small className="form-text text-muted">
                      Fecha en la que obtuvo el documento
                    </small>
                    <Form.Control.Feedback type="invalid">
                      **Campo requerido
                    </Form.Control.Feedback>
                  </Form.Group>
                </Row>
                <hr />
                <p className="text-muted ml-2">
                  Archivos actuales de estado civil
                </p>
                <hr />
                {edit && editItem.estado_civil_archivo ? (
                  <>
                    <ul className="list-unstyled">
                      {editItem.estado_civil_archivo.map((item) => (
                        <LinkDescargaGD
                          id={item.id}
                          filters={{
                            email: email,
                            id: item.id_documento,
                            llave: item.llave,
                          }}
                          origen={item.origen}
                          cType={item.contentTypeGD}
                        />
                      ))}
                    </ul>
                    <hr />
                  </>
                ) : null}
              </>
            ) : null}
            <p className="pl-2 text-muted form-text">Apartado de Croquis</p>
            <hr />
            <Row>
              <Form.Group as={Col} xs="8" sm="8" md="5" className="text-left">
                <Row>
                  <Col>
                    <Form.File
                      id="formcheck-api-regular"
                      className={croquisError ? `is-invalid` : ""}
                    >
                      <Form.File.Label>Subir croquis:</Form.File.Label>
                      <Form.File.Input
                        accept="image/*"
                        id="imagenCroquis"
                        name="imagenCroquis"
                      />
                    </Form.File>
                    <Form.Control.Feedback type="invalid" tooltip>
                      **Es requerido un archivo de menor peso
                    </Form.Control.Feedback>
                  </Col>
                </Row>
              </Form.Group>
            </Row>
            <Row>
              <Col className="pl-2">
                <div class="rounded mb-3">
                  {edit &&
                    editItem &&
                    editItem.croquis &&
                    editItem.croquis.length > 0 && (
                      <>
                        <hr />
                        <p class="ml-2">Archivos actuales ubicación</p>
                        <hr />
                        <ul className="list-unstyled">
                          {editItem.croquis.map((item) => (
                            <LinkDescargaGD
                              id={item.id}
                              filters={{
                                email: email,
                                id: item.id_documento,
                                llave: item.llave,
                              }}
                              origen={item.origen}
                              cType={item.contentTypeGD}
                            />
                          ))}
                        </ul>
                      </>
                    )}
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={
                saveLoading ||
                personalDivisionLoader ||
                loadingJobs ||
                employeesHierarchyLoader ||
                loadingAreas ||
                currentSituationLoader ||
                classificationLoader ||
                centerCostLoader ||
                divisionLoader ||
                auroraDivisionLoader ||
                employmentRelationLoader
              }
              variant="primary"
              type="submit"
            >
              {saveLoading ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : null}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showModalMenu}
        size="lg"
        onHide={() => setShowModalMenu(false)}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/contactos-emergencia/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Contactos de emergencia
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/familiares-dependientes/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Familiares dependientes
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/familiares-beneficiarios-seguro/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Beneficiarios
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/educacion-emp/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Mantenimiento de ficha de educación
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/salud-mantenimiento/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Mantenimiento de ficha de salud
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/historial-laboral/${employeeId}/${employeeName}/${props.match.params.oType}`}
              >
                Historial laboral
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/documentacion-empleados/${props.match.params.oType}/${employeeId}/${employeeName}`}
              >
                Documentos
              </Link>
            </Col>
            <Col md="3" className="mb-2">
              <Link
                style={{ height: "100px" }}
                className="btn btn-primary d-flex justify-content-center align-items-center"
                to={`/vacunas-empleados/${props.match.params.oType}/${employeeId}/${employeeName}`}
              >
                Mantenimiento de vacunas
              </Link>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="rounded-pill"
            variant="secondary"
            onClick={() => setShowModalMenu(false)}
          >
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Employees;
